import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DpListComponent } from './dp-list/dp-list.component';
import { DpDetailComponent } from './dp-detail/dp-detail.component';
import { SharedModule } from '@shared/shared.module';
import { DpDetailInfoComponent } from './dp-detail-info/dp-detail-info.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PageTitleComponent } from '@components/page-title/page-title.component';
import { DpFieldError } from '@components/dp-field-error/dp-field-error.component';
import { FontAwesomeComponent } from './font-awesome/font-awesome.component';
import { DpStatusBadgeComponent } from './dp-status-badge/dp-status-badge.component';
import { NoResultTableComponent } from './no-result-table/no-result-table.component';
import { NoResultComponent } from './no-result/no-result.component';
import { GooglePlacesAutocompleteComponent } from './google-places-autocomplete/google-places-autocomplete.component';
import { DpAvatarComponent } from '@components/dp-avatar/dp-avatar.component';
import { DpBadgeComponent } from './dp-badge/dp-badge.component';
import { DpProgressComponent } from './dp-progress/dp-progress.component';
import { DpBadgeNameComponent } from './dp-badge-name/dp-badge-name.component';
import { StarRatingComponent } from './star-rating/star-rating.component';
import { DpImgSelectComponent } from './dp-img-select/dp-img-select.component';
import { DpFormDataFileSelectComponent } from '@components/dp-form-data-file-select/dp-form-data-file-select.component';
import { DpFileSelectComponent } from '@components/dp-file-select/dp-file-select.component';
import {
  GooglePlacesAutocompleteCPComponent,
} from './google-places-autocomplete-cp/google-places-autocomplete-cp.component';

@NgModule({
  declarations: [
    DpListComponent,
    DpDetailComponent,
    DpDetailInfoComponent,
    PageTitleComponent,
    NotFoundComponent,
    DpFieldError,
    FontAwesomeComponent,
    DpStatusBadgeComponent,
    NoResultTableComponent,
    NoResultComponent,
    GooglePlacesAutocompleteComponent,
    GooglePlacesAutocompleteCPComponent,
    DpAvatarComponent,
    DpBadgeComponent,
    DpProgressComponent,
    DpBadgeNameComponent,
    StarRatingComponent,
    DpImgSelectComponent,
    DpFileSelectComponent,
    DpFormDataFileSelectComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [
    DpListComponent,
    DpDetailComponent,
    DpDetailInfoComponent,
    PageTitleComponent,
    NotFoundComponent,
    DpFieldError,
    FontAwesomeComponent,
    DpStatusBadgeComponent,
    NoResultTableComponent,
    NoResultComponent,
    GooglePlacesAutocompleteComponent,
    GooglePlacesAutocompleteCPComponent,
    DpAvatarComponent,
    DpBadgeComponent,
    DpProgressComponent,
    DpBadgeNameComponent,
    StarRatingComponent,
    DpImgSelectComponent,
    DpFileSelectComponent,
    DpFormDataFileSelectComponent,
  ]
})
export class ComponentsModule {
}
